import { z } from 'zod';
import { zOperationalStatus, zServiceType } from './enums';

/**
 * OpenStatus is computed by a cron job, not user-editable.
 **/

export const openStatusSchema = z.object({
  isOnlineNow: z.boolean().default(false),
  isOpenNow: z.boolean().default(false),
  restaurantId: z.string(),
  serviceTypesAvailableNow: z.array(zServiceType).default([]),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type OpenStatus = z.output<typeof openStatusSchema>;

/** Strict schema */
export const openStatusStrictSchema = openStatusSchema;

/** Convex schema */
export const openStatusCvxSchema = openStatusSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type OpenStatusCvx = z.output<typeof openStatusCvxSchema>;

/** Convex schema with calculated fields */
export const openStatusCvxCalcSchema = openStatusCvxSchema.safeExtend({
  operationalStatus: zOperationalStatus,
});
export type OpenStatusCvxCalc = z.output<typeof openStatusCvxCalcSchema>;
